import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ScrollIndicator } from '../../../components/ScrollIndicator';
import { useCountryMarketState } from '../../../controllers/CountryMarketController/CountryMarketState';
import { Step } from '../../../types/misc';
import { useBriefingState } from '../BriefingState';

interface BriefingProgressProps {
  step: Step;
  isNavDisabled: boolean;
}

export const BriefingProgress: FC<BriefingProgressProps> = ({
  step,
  isNavDisabled,
}: BriefingProgressProps) => {
  const [{ steps, maxStepIndexAlreadyReached, branch }] = useBriefingState();
  const [{ countryMarketConfig }] = useCountryMarketState();
  const { t } = useTranslation();

  // For the Modify flow on HomeCareIndustrialCleaning market, we want to remove the
  // first two steps from the ScrollIndicator
  const filteredSteps = useMemo(() => {
    if (countryMarketConfig?.eLabMarketSlug === 'HomeCareIndustrialCleaning') {
      return steps.filter((hcicStep) => !hcicStep.includes('modification'));
    } else {
      return steps;
    }
  }, [steps, countryMarketConfig]);

  return (
    <>
      <div className="flex flex-col justify-center flex-grow md:ml-4">
        {!step.includes('modification') && (
          <ScrollIndicator
            step={filteredSteps.indexOf(step) + 1}
            of={filteredSteps.length}
            steps={filteredSteps}
            stepNames={filteredSteps.map((s) =>
              t([`topics:${s}:name:${branch}`, `topics:${s}:name`]),
            )}
            disabled={isNavDisabled}
            maxStepReached={maxStepIndexAlreadyReached}
            baseUrl={`/${countryMarketConfig?.eLabCountrySlug}/${countryMarketConfig?.eLabMarketSlug}/briefing/${branch}`}
          />
        )}
      </div>
    </>
  );
};
